import types from "../types";
import { copy } from "../../utils";
import backend from "../../api"

const loading = val => (dispatch, getState) => {
	const state = copy(getState().global)
	state.loading = val
	dispatch({
		type: types.GLOBAL,
		payload: state
	})
}

export default { loading }